export default __webpack_public_path__ + "static/media/specialcustomer.2be5c971.svg";